var map = {
	"./assets/clickable/midrag.svg": "dfdebf035678d87ce4e7",
	"./assets/disabled/midrag.svg": "e0e7d1c2d603b6139bea",
	"./assets/original/midrag.svg": "5595d63db84b5eef8802"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a9f442f17aad11295865";